export default __webpack_public_path__ + "static/media/double_check.363bb102.svg";